import { createThemedComponent } from "@vitalsource/vstui/themes";
import React from "react";
import { Button } from "@vitalsource/vstui";
import { BUTTON_PROPS, BUTTON_SIZE, getBarColor } from "./vars";
import styled from "styled-components";

const Styled = {
  Container: styled.div`
    display: inline-block;
    width: ${BUTTON_SIZE}px;
  `
};

function getFocus(props) {
  return `${getBarColor(
    props
  )} 0px 0px 0px 3px, rgba(255, 255, 255, 0.8) 0px 0px 0px 5px`;
}

const ThemedButton = createThemedComponent(Button, {
  ...BUTTON_PROPS,
  Button_borderRadius: `${BUTTON_SIZE}px`,
  Button_borderWidth: 1,
  Button_borderColor_whiteNaked: "#fff",
  Button_borderColor_whiteNaked_focus: "#fff",
  Button_borderColor_whiteNaked_active: "#fff",
  Button_borderColor_whiteNaked_hover: "rgba(255, 255, 255, 0.8)",
  Button_borderColor_whiteNaked_disabled: "rgba(255, 255, 255, 0.8)",
  Button_boxShadow_whiteNaked_focus: getFocus
});

export default function CircleButton({ icon, label, onClick, disabled }) {
  return (
    <Styled.Container>
      <ThemedButton
        iconStart={icon}
        color="white"
        naked
        label={label}
        onClick={onClick}
        disabled={disabled}
        fullWidth
      />
    </Styled.Container>
  );
}
